export default [
  {
    id: 'stripe',
    allowReusableUse: true,
    allowSingleUse: true,
    currencies: ['USD', 'MXN'],
    flow: 'none',
    name: 'Stripe',
    testMode: {
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      card: {
        number: '4242 4242 4242 4242',
        date: '12 / 25',
        cvv: '123'
      }
    }
  },
  {
    id: 'paypal',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['USD', 'MXN'],
    flow: 'redirect',
    name: 'PayPal'
  },
  {
    id: 'oneclick',
    allowReusableUse: true,
    allowSingleUse: false,
    currencies: ['CLP'],
    flow: 'redirect',
    name: 'OneClick Transbank'
  },
  {
    id: 'mercadopago',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['CLP'],
    flow: 'none',
    name: 'Mercado Pago'
  },
  {
    id: 'twocheckout',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['USD'],
    flow: 'none',
    title: '2Checkout'
  }
]